import ReactECharts from 'echarts-for-react';

const ECharts = ({ option }) => {
    return (
        <div style={{ height: '100%' }}>
            <ReactECharts
                style={{ minHeight: 500 }}
                option={option} />
        </div>
    )
}

export default ECharts